import { AxiosResponse } from "axios";
import { RestServiceConnection } from "../restServiceConnection";

const RECURRENT_PRODUCT_ENDPOINT = "/recurrent-products";

export class RecurrentProductService extends RestServiceConnection {

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE PRODUCTOS RECURRENTES
     * @EN GETS THE LIST OF RECURRENT PRODUCTS
     */
    // -------------------------------------------------------------------------------------------------------------
    listRecurrentProducts = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: RECURRENT_PRODUCT_ENDPOINT + "/list",
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE UNA SEDE POR SU ID
     * @EN GETS A HEADQUARTER BY ITS ID
     */
    // -------------------------------------------------------------------------------------------------------------
    getRecurrentProductById = async (id: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: RECURRENT_PRODUCT_ENDPOINT + "/get",
            data: { id: id },    
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES TOGGLEA UNA SEDE
     * @EN TOGGLES A HEADQUARTER
     */
    // -------------------------------------------------------------------------------------------------------------
    toggleHeadquarterStatus = async (headquarterId: string, status: boolean) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: RECURRENT_PRODUCT_ENDPOINT + "/toggle",
            data: { id: headquarterId, active: status },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES CREA UN PRODUCTO RECURRENTE
     * @EN CREATES A RECURRENT PRODUCT
     */
    // -------------------------------------------------------------------------------------------------------------
    createRecurrentProduct = async (recurrentProduct: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: RECURRENT_PRODUCT_ENDPOINT + "/create",
            data: recurrentProduct,  
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES EDITA UN PRODUCTO RECURRENTE
     * @EN EDITS A RECURRENT PRODUCT
     */
    // -------------------------------------------------------------------------------------------------------------
    editRecurrentProduct = async (recurrentProduct: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: RECURRENT_PRODUCT_ENDPOINT + "/edit",
            data: recurrentProduct,  
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA UN PRODUCTO RECURRENTE
     * @EN DELETES A RECURRENT PRODUCT
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteRecurrentProduct = async (recurrentProductId: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: RECURRENT_PRODUCT_ENDPOINT + "/delete",
            data: { id: recurrentProductId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA VARIOS PRODUCTOS RECURRENTES
     * @EN DELETES MULTIPLE RECURRENT PRODUCTS
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteMultiRecurrentProduct = async (recurrentProductIds: string[]) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: RECURRENT_PRODUCT_ENDPOINT + "/delete-multi",
            data: { 
                ids: recurrentProductIds,
            },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

}